import AxiosClient from "../../../services/axios.services";

class PeriodConfigServices {
  getPeriodConfig = (params) =>
    AxiosClient.get("/api/app/evaluacion_configuracion_periodo/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getPeriodConfigById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_configuracion_periodo/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  savePeriodConfig = (data) =>
    AxiosClient.post("/api/app/evaluacion_configuracion_periodo/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editPeriodConfig = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_configuracion_periodo/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deletePeriodConfig = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_configuracion_periodo/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new PeriodConfigServices();
